import React from 'react';
import {
    Row,
    Col,
    Accordion,
    AccordionTitle,
    AccordionContent,
    Icon,
    AccordionGroup,
} from '@si-armes/dsfr-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import usagerClientReducer from '../../../../../store/usagerReducer';
import { getAPI, postAPI, reinitialiseAPI } from '../../../../../store/apiReducer';
import {
    API_GET_EXPORT_REFERENTIEL_PAYS,
    CONTEXT_GET_EXPORT_REFERENTIEL_PAYS,
    EXPORT_REFERENTIEL_PAYS,
} from '../../../../../constants/apiUrls.constants';
import BoutonFichierTelechargeable from '../../../../../components/Commun/Fichier/BoutonFichierTelechargeable';
import { MIME_TEXT_CSV } from '../../../../../constants/fileConstant';

const ReglesImport = ({ getApi, referentielPays }) => {
    const telechargerReferentiel = () => {
        getApi(
            usagerClientReducer,
            API_GET_EXPORT_REFERENTIEL_PAYS,
            CONTEXT_GET_EXPORT_REFERENTIEL_PAYS,
        );
    };

    return (
        <Row>
            <Col col={12}>
                <AccordionGroup defaultExpanded="informations">
                    <Accordion id="informations">
                        <AccordionTitle>
                            <Icon icon="fr-fi-question-fill" className="margin-right-sm" />
                            Importer, les règles à respecter
                        </AccordionTitle>
                        <AccordionContent>
                            <Row>
                                <Col col={6} className="padding-carte">
                                    <ul>
                                        <li>Les fichiers ne doivent pas dépasser 2 mo</li>
                                        <li>Le fichier ne doit pas être vide</li>
                                        <li>Les entêtes du fichier ne doivent pas être modifiés</li>
                                        <li>
                                            La raison du dépôt doit être orthographiée de la manière
                                            suivante : "entree en stock"
                                        </li>
                                        <li>
                                            La colonne neutralisée doit être renseignée à oui ou non
                                        </li>
                                        <li>
                                            Le fichier à importer doit être en format CSV et encodé
                                            en UTF-8
                                        </li>
                                    </ul>
                                </Col>
                                <Col col={6} className="padding-carte">
                                    <ul>
                                        <li>Les colonnes avec un astérisque sont obligatoires</li>
                                        <li>Le numéro SIA est le numéro du propriétaire</li>
                                        <li>
                                            Le pays doit correspondre à notre référentiel des pays.{' '}
                                        </li>
                                    </ul>
                                    <BoutonFichierTelechargeable
                                        handleOnClick={telechargerReferentiel}
                                        titreFichier={EXPORT_REFERENTIEL_PAYS}
                                        mimeType={MIME_TEXT_CSV}
                                        label="Télécharger le référentiel des pays"
                                        contenu={referentielPays?.contenu}
                                        iconOnly
                                    />
                                </Col>
                            </Row>
                        </AccordionContent>
                    </Accordion>
                </AccordionGroup>
            </Col>
        </Row>
    );
};

ReglesImport.propTypes = {
    getApi: PropTypes.func.isRequired,
    referentielPays: PropTypes.object,
};

export default connect(
    (state) => {
        const { data: referentielPays } = state.armes.ajoutArmeEnMasse.referentielPays;

        return {
            referentielPays,
        };
    },
    {
        postApi: postAPI,
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ReglesImport);
